//用户接口相关的函数
import request from "../untils/request.js"


// 云南医保请求数据备份保存
export const addYbRquestData = (data) => {
    return request.post('/outpatient/insurance/yn_req', data);
};

// 云南医保响应数据备份保存
export const addYbResponseData = (data) => {
    return request.post('/outpatient/insurance/yn_resp', data);
};

// 云南医保响应数据 => 上传所有医保返回的数据
export const toUploadLY = (data) => {
    return request.post('/outpatient/insurance/yn_resp', data);
};

// 医保接口-获取签到编号 （医保签退时候用）
export const getqdNo = (params) => {
    return request.get('/outpatient/insurance/yn_getSignNo', {params});
};

// 医保接口获取库存信息 （医保库存变化时候用）
export const changeYB = (params) => {
    return request.get('/outpatient/getDrugCntEdit', {params});
};

// 暴露
export default{
addYbRquestData,
toUploadLY,
getqdNo,
changeYB
}